export default __webpack_public_path__ + "static/media/telescope.0bfec0a0.png";